import { map, first, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Directive, forwardRef, Input, Attribute, OnInit, OnChanges } from '@angular/core';
import { NG_ASYNC_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { HttpClientService } from '../services/common/http-client.service';

@Directive({
  selector: '[uniqueValidator][formControlName], [uniqueValidator][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => UniqueValidatorDirective),
      multi: true,
    },
  ],
})
export class UniqueValidatorDirective implements OnInit, Validator, OnChanges {
  @Input('uniqueValidator') validationURL: string;

  actualURL: string;

  data: any = {};

  constructor(private httpClient: HttpClientService, @Attribute('valueUnique') public valueUnique: string) {}

  ngOnInit() {
    if (this.validationURL) this.parseURL();
  }

  ngOnChanges(changes: any) {
    if (changes.validationURL && changes.validationURL.currentValue) this.parseURL();
  }

  parseURL() {
    this.data = {};
    let url = this.validationURL.split('?');
    if (url[1]) {
      let params = url[1].split('&');
      for (var i in params) {
        let param_value = params[i].split('=');
        this.data[param_value[0]] = param_value[1];
      }
    }
    this.actualURL = url[0];
  }

  validate(c: AbstractControl): Promise<{ [key: string]: any }> | Observable<{ [key: string]: any }> {
    return this.validateUniqueValue(c.value).pipe(
      debounceTime(500),
      distinctUntilChanged(),
      first(),
      map((res) => {
        if (res.notUnique) return res;
        else return;
      })
    );
  }

  validateUniqueValue(value: string): Observable<any> {
    this.data.value = value;
    this.data.unique_validation = true;
    return this.httpClient.getObservable(`${this.actualURL}.json`, this.data);
  }
}
